module.exports = __webpack_public_path__ + "img/IG_LOGO.f7f657b1.png";